import React from 'react';

import { type ClusterAsset, ClusterSidebarAsset } from './ClusterSidebarAsset';

type ClusterSidebarContentProps = {
    assets?: ClusterAsset[];
    onSelectAsset?: (assetId: string) => void;
};

export const ClusterSidebarContent = React.memo(
    ({ assets = [], onSelectAsset = () => {} }: ClusterSidebarContentProps) => (
        <div className='ClusterSidebarContent padding-x-20 padding-top-5'>
            {assets.map(asset => {
                const assetId = asset.vehicleId;
                return (
                    <ClusterSidebarAsset
                        key={assetId}
                        asset={asset}
                        onClick={assetId ? () => onSelectAsset(assetId) : undefined}
                    />
                );
            })}
        </div>
    )
);
